<template>
  <div class="login-box">
    <el-form :model="user" ref="form" label-width="80px" :inline="false" size="normal" autocomplete="off" @keyup.enter.native="login">
      <el-form-item label="手机号" prop="phone" :rules="[
            { required: true, message: '请输入手机号', trigger: 'blur' },
            { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
          ]">
        <el-input type="tel" v-model="user.phone" placeholder="请输入11位手机号" maxlength="11"></el-input>
      </el-form-item>

      <el-form-item label="密码" prop="password" :rules="[{ required: true, message: '请输入密码', trigger: 'blur' }]">
        <el-input type="password" v-model="user.password" placeholder="请输入密码" autocomplete="new-password"></el-input>
      </el-form-item>
      <el-form-item label="验证码" prop="validUserCode" :rules="[{ required: true, message: '请输入验证码', trigger: 'blur' }]">
        <el-input style="width: 150px; vertical-align: top;" v-model="user.validUserCode" placeholder="请输入验证码"></el-input>
        <div class="validImage" v-loading="loading" title="点击刷新验证码">
          <img @click="getValidImage()" :src="imgSrc" alt="">
        </div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-unlock" @click="login()">登录</el-button>
        <el-button style="margin-left: 50px" type="text" icon="el-icon-lock" @click="forgotDialogVisible = true">忘记密码</el-button>
      </el-form-item>
    </el-form>

    <el-dialog title="忘记密码" :visible.sync="forgotDialogVisible" :width="$wd.w < 500 ? '100%' : '400px'">
      <div style="font-size: 16px">
        若您忘记密码，可点击网站上方“联系客服”获取电话信息，联系客服帮您重置密码。
      </div>
      <span slot="footer">
        <el-button @click="forgotDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
export default {
  props: ['path'],
  data () {
    return {
      forgotDialogVisible: false,
      loading: false,
      imgSrc: '',
      user: {
        phone: '',
        password: '',
        validUserCode: ''
      }
    }
  },
  created () {
    this.getValidImage()
  },
  methods: {
    validatePassword (rule, value, callback) {
      if (!value) {
        callback(new Error('请输入密码'))
      } else {
        callback()
      }
    },
    getValidImage () {
      this.loading = true
      this.user.validImageCode = this.$tool.UUID()
      this.$http.post('/common/service/getValidCode', { validImageCode: this.user.validImageCode }).then((res) => {
        setTimeout(() => {
          this.loading = false
          this.imgSrc = 'data:image/png;base64,' + res.data
        }, 500)
      })
    },
    successLogin () {
      if (this.path) {
        window.location.href = this.path
      } else {
        setTimeout(() => {
          window.location.reload()
        }, 500)
      }
    },
    login () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$passwordCrypto.encryptForm(this.$http, this.user, 'password').then((body) => {
            this.$http.post('/user/service/login', body).then((res) => {
              if (res.status) {
                this.$cookie.set('YZSTOKEN', res.data.token, 30)
                const name = res.data.user.name || res.data.user.phone
                this.$cookie.set('YZSNAME', name, 30)
                this.$cookie.set('YZSUSERID', res.data.user.id, 30)
                this.$message.success(res.data.message)
                this.successLogin()
              } else {
                this.$message.error(res.data.message)
              }
            }).catch(() => {
              this.getValidImage()
              this.user.validUserCode = ''
            })
          }).catch((e) => {
            this.$message.error(e.message || '密码加密失败')
          })
        } else {
          this.$message.warning('请完善表单信息')
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.login-box {
  .validImage {
    border-radius: 3px;
    vertical-align: top;
    margin-left: 10px;
    height: 40px;
    width: 120px;
    cursor: pointer;
    user-select: none;
    display: inline-block;
    img {
      height: 100%;
      width: 100%;
      border: 1px solid #ccc;
      border-radius: 3px;
    }
  }
}
</style>
